class ProductTabsElement extends HTMLElement {
  /** @type {HTMLButtonElement[]} */
  tabButtons = [];

  /** @type {HTMLElement[]} */
  panels = [];

  connectedCallback() {
    this.tabButtons = Array.from(this.querySelectorAll('.product-tabs__tab'));
    this.panels = Array.from(this.querySelectorAll('.product-tabs__panel'));

    if (this.tabButtons.length === 0 || this.panels.length === 0) {
      return;
    }

    this.tabButtons.forEach((button, index) => {
      button.addEventListener('click', () => this.activate(index));
      button.addEventListener('keydown', (event) => this.onKeydown(event, index));
    });

    this.activate(0);
  }

  /**
   * @param {number} index
   */
  activate(index) {
    const last = this.tabButtons.length - 1;
    const i = ((index % (last + 1)) + (last + 1)) % (last + 1);

    this.tabButtons.forEach((btn, j) => {
      const isActive = j === i;
      btn.setAttribute('aria-selected', String(isActive));
      btn.classList.toggle('product-tabs__tab--active', isActive);
      btn.tabIndex = isActive ? 0 : -1;
    });

    this.panels.forEach((panel, j) => {
      panel.hidden = j !== i;
    });
  }

  /**
   * @param {KeyboardEvent} event
   * @param {number} index
   */
  onKeydown(event, index) {
    const { key } = event;
    const last = this.tabButtons.length - 1;

    if (key === 'ArrowRight' || key === 'ArrowDown') {
      event.preventDefault();
      const next = index >= last ? 0 : index + 1;
      this.activate(next);
      this.tabButtons[next]?.focus();
    } else if (key === 'ArrowLeft' || key === 'ArrowUp') {
      event.preventDefault();
      const prev = index <= 0 ? last : index - 1;
      this.activate(prev);
      this.tabButtons[prev]?.focus();
    } else if (key === 'Home') {
      event.preventDefault();
      this.activate(0);
      this.tabButtons[0]?.focus();
    } else if (key === 'End') {
      event.preventDefault();
      this.activate(last);
      this.tabButtons[last]?.focus();
    }
  }
}

customElements.define('product-tabs', ProductTabsElement);
